import { twMerge } from "tailwind-merge";

export type ClassValue = string | false | null | undefined;

/**
 * Class-name joiner with Tailwind-aware conflict resolution: when two
 * classes touch the same CSS property (e.g. `text-sm` and `text-base`),
 * the later one wins, regardless of the order Tailwind happened to emit the
 * underlying utilities in. A plain filter+join joiner picks a winner based
 * on utility source order instead of call order, so `cn("text-sm", "text-base")`
 * could silently keep `text-sm` — see the cn.test.ts cases pinned from real
 * primitives where this happened (h-12/px-4 overrides won, text-base/
 * rounded-full silently lost).
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(classes.filter(Boolean).join(" "));
}
